import { createAction } from '@reduxjs/toolkit';
import { Company, PermissionSetType } from 'api/models';
import { ProjectPhase } from 'api/project';
import { InvitedMembers } from 'data/members/slice';
import { DateShiftUpdates, List } from 'utils/date-shift';

interface ProjectPhaseActionPayloadOptions {
  skipStoreUpdate?: boolean;
  isSync?: boolean;
  toggleUpdating?: (_value: boolean) => void;
}

interface UpdateProjectPhaseDatesData {
  projectId: number;
  phaseId: number;
  startDate: string;
  dueDate: string;
}

export interface ProjectPhaseDatesActionPayload {
  data: UpdateProjectPhaseDatesData;
  options?: ProjectPhaseActionPayloadOptions;
}

interface UpdateProjectSprintDatesData {
  sprintId: number;
  startDate: string;
  dueDate: string;
}

export interface ProjectSprintDatesActionPayload {
  data: UpdateProjectSprintDatesData;
  options?: ProjectPhaseActionPayloadOptions;
}

export interface GetProjectPayload {
  projectId: number; // TODO:: move to Projectid
  handleSuccess?(): void;
  handleError?(): void;
}

interface RemoveMembers {
  userId: number;
}

export interface CreateAndInviteProjectMembers {
  user: {
    emailId: string;
    company: Pick<Company, 'companyId'>;
    permissionSet?: {
      permissionSetType: PermissionSetType;
    };
    fields?: {
      fieldId: number;
      fieldValue: unknown;
    }[];
  };
}

export const getProjectById = createAction<GetProjectPayload>(
  '@@projects/GET_PROJECT_BY_ID_SAGA',
);

export const updateProjectPhaseDatesAction =
  createAction<ProjectPhaseDatesActionPayload>(
    '@@projects/updateProjectPhaseDates',
  );

export const updateProjectSprintDatesAction =
  createAction<ProjectSprintDatesActionPayload>(
    '@@projects/updateProjectSprintDates',
  );

export const updatePhaseDatesAction =
  createAction<ProjectPhaseDatesActionPayload>(
    '@@projects/UPDATE_PHASE_DATES_SAGA',
  );

interface Callback {
  (data: any): void;
}

export const addMembersToProject = createAction<{
  projectId: number;
  members: InvitedMembers[];
  handleSuccess?: Callback;
  handleFailure?: Callback;
}>('@@projects/ADD_MEMBERS_TO_PROJECT_SAGA');

export const createAndInviteProjectMembersAction = createAction<{
  projectId: number;
  data: (CreateAndInviteProjectMembers | InvitedMembers)[];
  handleSuccess?: Callback;
  handleFailure?: Callback;
}>('@@projects/CREATE_AND_INVITE_PROJECT_MEMBERS');

export const removeMembersFromProject = createAction<{
  projectId: number;
  members: RemoveMembers[];
  handleSuccess?: Callback;
  handleFailure?: Callback;
}>('@@projects/REMOVE_MEMBERS_FROM_PROJECT_SAGA');

export const updateProjectMembers = createAction<{
  projectId: number;
  members: {
    user: {
      userId: number;
    };
    permissionSet: {
      permissionSetType: number;
    };
  }[];
  handleSuccess?: Callback;
  handleFailure?: Callback;
}>('@@projects/UPDATE_PROJECT_MEMBERS_SAGA');

export const setGanttRefAction = createAction<any>(
  '@@projects/SET_GANTT_REF_SAGA',
);

interface UpdateGanttDatesPayload {
  phaseUpdates: DateShiftUpdates;
  taskUpdates: DateShiftUpdates;
  phaseList: List;
  taskList: List;
  projectPhases: ProjectPhase[];
  sprintUpdates: DateShiftUpdates;
  sprintList: List;
}
export const updateGanttDatesAction = createAction<UpdateGanttDatesPayload>(
  '@@projects/UPDATE_GANTT_DATES_SAGA',
);

export const updateGanttSlackAction = createAction<any>(
  '@@projects/UPDATE_GANTT_SLACK_SAGA',
);
